<p-message [severity]="pMessageSeverity" [styleClass]="pMessageStyleClass">
    <div class="flex flex-column gap-2 w-full">
        <div class="flex align-items-start gap-3">

            @if (icon) {
            <i [ngClass]="icon" class="mt-1 flex-shrink-0" style="font-size: 1.25rem"></i>
            }

            <div class="flex flex-column flex-1 gap-2">

                <!-- Titre, et sa note alignée à droite -->
                <div class="flex align-items-baseline flex-wrap column-gap-3 row-gap-1" style="padding-top: 3px;">
                    <span class="flex-1 font-semibold">{{ title }}</span>
                    @if (titleNote) {
                    <span class="text-500 text-sm">{{ titleNote }}</span>
                    }
                </div>

                <!-- Messages (support HTML pour les liens) -->
                @for (msg of messages; track $index) {
                <div class="text-color" [innerHTML]="msg"></div>
                }

                <!-- Actions -->
                @if (primaryAction || secondaryActions?.length) {
                <div class="flex align-items-center gap-2 flex-wrap mb-1 mt-2">
                    @if (primaryAction) {
                    <p-button [label]="primaryAction.label" size="small" [rounded]="true"
                        [loading]="primaryAction.loading ?? false" [disabled]="primaryAction.disabled ?? false"
                        [severity]="effectiveButtonSeverity"
                        [pTooltip]="primaryAction.tooltip ?? ''" tooltipPosition="top"
                        (click)="primaryAction.handler()"></p-button>
                    }
                    @for (action of secondaryActions; track action.label) {
                    <p-button [label]="action.label" size="small" [outlined]="true" [rounded]="true"
                        [loading]="action.loading ?? false" [disabled]="action.disabled ?? false"
                        [severity]="effectiveButtonSeverity"
                        [pTooltip]="action.tooltip ?? ''" tooltipPosition="top"
                        (click)="action.handler()"></p-button>
                    }
                </div>
                }

            </div>
        </div>
    </div>
</p-message>
